import BoosterIcon from '@/comp/common/icons/BoosterIcon';
import CompressorIcon from '@/comp/common/icons/CompressorIcon';
import DesiccantAirDryerIcon from '@/comp/common/icons/DesiccantAirDryerIcon';
import ProductionFloorIcon from '@/comp/common/icons/ProductionFloorIcon';
import RefrigeratedAirDryerIcon from '@/comp/common/icons/RefrigeratedAirDryerIcon';
import TankIcon from '@/comp/common/icons/TankIcon';
import { airTankTypes, compressorTypes, DeviceType } from '@/constants/deviceTypeEnum';

export const assetItemIconMapping = {
  comp: { types: compressorTypes, icon: <CompressorIcon /> },
  refDryer: { types: [DeviceType.RefrigeratedAirDryer], icon: <RefrigeratedAirDryerIcon /> },
  desDryer: { types: [DeviceType.DesiccantAirDryer], icon: <DesiccantAirDryerIcon /> },
  tank: { types: airTankTypes, icon: <TankIcon /> },
  booster: { types: [DeviceType.Booster], icon: <BoosterIcon /> },
  prodFloor: { types: [DeviceType.ProductionFloor], icon: <ProductionFloorIcon /> },
};
